/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../script-hack/script-hack.component.ngfactory';
import * as i2 from '../../../../../app/shared/components/script-hack/script-hack.component';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../app/shared/components/buzzlead/buzzlead.component';
import * as i5 from '@angular/router';
const styles_BuzzleadComponent:any[] = ([] as any[]);
export const RenderType_BuzzleadComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_BuzzleadComponent,data:{}});
function View_BuzzleadComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'script-hack',
      [['src','https://app.buzzlead.com.br/tracker.js'],['type','text/javascript']],
      (null as any),[[(null as any),'loaded']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('loaded' === en)) {
          const pd_0:any = ((<any>_co.executeTrack()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i1.View_ScriptHackComponent_0,i1.RenderType_ScriptHackComponent)),i0.ɵdid(1,
      4374528,(null as any),0,i2.ScriptHackComponent,[i0.ChangeDetectorRef],{src:[0,
          'src'],type:[1,'type'],appendToBody:[2,'appendToBody']},{loaded:'loaded'})],
      (_ck,_v) => {
        const currVal_0:any = 'https://app.buzzlead.com.br/tracker.js';
        const currVal_1:any = 'text/javascript';
        const currVal_2:any = true;
        _ck(_v,1,0,currVal_0,currVal_1,currVal_2);
      },(null as any));
}
export function View_BuzzleadComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_BuzzleadComponent_1)),i0.ɵdid(1,16384,(null as any),0,i3.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i4.BuzzleadComponent = _v.component;
    const currVal_0:any = _co.ready;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_BuzzleadComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'buzzlead',([] as any[]),
      (null as any),(null as any),(null as any),View_BuzzleadComponent_0,RenderType_BuzzleadComponent)),
      i0.ɵdid(1,114688,(null as any),0,i4.BuzzleadComponent,[i5.ActivatedRoute],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const BuzzleadComponentNgFactory:i0.ComponentFactory<i4.BuzzleadComponent> = i0.ɵccf('buzzlead',
    i4.BuzzleadComponent,View_BuzzleadComponent_Host_0,{offer:'offer'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMjA3ODAyOTM4OC9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9idXp6bGVhZC9idXp6bGVhZC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmMyMDc4MDI5Mzg4L3NyYy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2J1enpsZWFkL2J1enpsZWFkLmNvbXBvbmVudC50cyIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMjA3ODAyOTM4OC9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9idXp6bGVhZC9idXp6bGVhZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjMjA3ODAyOTM4OC9zcmMvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9idXp6bGVhZC9idXp6bGVhZC5jb21wb25lbnQudHMuQnV6emxlYWRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2NyaXB0LWhhY2sgKm5nSWY9XCJyZWFkeVwiIFthcHBlbmRUb0JvZHldPVwidHJ1ZVwiXG4gICAgICAgICAgICAgKGxvYWRlZCk9XCJleGVjdXRlVHJhY2soKVwiXG4gICAgICAgICAgICAgdHlwZT1cInRleHQvamF2YXNjcmlwdFwiXG4gICAgICAgICAgICAgc3JjPVwiaHR0cHM6Ly9hcHAuYnV6emxlYWQuY29tLmJyL3RyYWNrZXIuanNcIj48L3NjcmlwdC1oYWNrPiIsIjxidXp6bGVhZD48L2J1enpsZWFkPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQ2E7VUFBQTtVQUFBO1FBQUE7UUFEYjtNQUFBLDJFQUFBO01BQUE7VUFBQTs7UUFHYTtRQURBO1FBRmM7UUFBM0IsV0FHYSxVQURBLFVBRmMsU0FBM0I7Ozs7b0JBQUE7TUFBQSxrQ0FBQTtvQkFBQTs7SUFBYTtJQUFiLFdBQWEsU0FBYjs7OztvQkNBQTtNQUFBO2FBQUE7VUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/$$_gendir/app/shared/components/buzzlead/buzzlead.component.ngfactory.ts